
import lazyLoadComponent from "@/scripts/lazyLoadComponent";
import SkeletonBox from "@/views/component/SkeletonBox";

export default {
    components: {
        RightBlockInfo: lazyLoadComponent({
            componentFactory: () => import("@/views/Promotion/RightBlockInfo"),
            loading: SkeletonBox
        }),
        TabPromotionContent: lazyLoadComponent({
            componentFactory: () => import("@/views/Promotion/TabPromotionContent"),
            loading: SkeletonBox
        }),
        TabCouponVoucherContent: lazyLoadComponent({
            componentFactory: () => import("@/views/Promotion/TabCouponVoucherContent"),
            loading: SkeletonBox
        }),
        TabAffilifateContent: lazyLoadComponent({
            componentFactory: () => import("@/views/Promotion/TabAffilifateContent"),
            loading: SkeletonBox
        }),
    },
    data() {
        return {
            activeTab: 'Promotions',
        }
    },
    watch: {
        '$route.query.type'(val) {
            if (val === 'affiliate') {
                this.activeTab = 'AffiliateProgram';
                this.$router.replace({ query: {} })
            }
        }
    },
    mounted() {
        const type = this.$route.query.type
        if (type === 'affiliate') {
            this.activeTab = 'AffiliateProgram';
            this.$router.replace({
                query: { ...this.$route.query, type: undefined }
            })
        }
    },
    
}